import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appMascara]',
})
export class MascaraDirective {
  public onTouched: any;
  public onChange: any;

  @Input('appMascara') public maskType: string;

  constructor(private el: ElementRef) {}

  public writeValue(value: any): void {
    if (value) {
      this.el.nativeElement.value = this.aplicarMascara(value, this.maskType);
    }
  }

  @HostListener('keyup', ['$event'])
  public onKeyup($event: any) {
    let valor = $event.target.value.replace(/[^a-z0-9]/gi, '').toUpperCase();

    // retorna caso pressionado backspace
    // if ($event.keyCode === 8) {
    // 	this.onChange(valor);
    // 	return;
    // }
    this.el.nativeElement.value = this.aplicarMascara(valor, this.maskType);
  }

  public aplicarMascara(valor: string, maskType: string): string {
    if (maskType === 'doc') {
      const size = this.getSizeMaskType('doc');
      const value = valor.slice(0, size);
      valor = value;
      if (valor.length <= 11) {
        valor = valor.replace(/\D/g, '');
        valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
        valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
        valor = valor.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      } else if (valor.length > 11 && valor.length <= 14) {
        valor = valor.replace(/\D/g, '');
        valor = valor.replace(/(\d{2})(\d)/, '$1.$2'); // 12.
        valor = valor.replace(/(\d{3})(\d)/, '$1.$2'); // 12.254.
        valor = valor.replace(/(\d{3})(\d)/, '$1/$2'); // 12.254.356/
        valor = valor.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); // 12.254.356/0001-25
      }
    }
    return valor;
  }

  public getSizeMaskType(maskType: string) {
    let size: number = 0;
    if (maskType === 'doc') {
      size = 14;
    } else if (maskType === 'telefone') {
      size = 11;
    } else if (maskType === 'cep') {
      size = 8;
    } else if (maskType === 'cpf') {
      size = 11;
    } else if (maskType === 'cnpj') {
      size = 14;
    } else if (maskType === 'telefonefixo') {
      size = 10;
    } else if (maskType === 'celular') {
      size = 11;
    }
    return size;
  }
}
